import gql from 'graphql-tag'

export default {
  MY_SCREEN_CASTS: gql`
    query activities(
      $startTime: DateTime!
      $endTime: DateTime!
      $keyword: [String!]
      $uuid: String
      $page: Int # $first: Int
      $timezone: String
    ) {
      me(uuid: $uuid) {
        id
        uuid
        idlePercent(
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        recordsDuration: activityDuration(
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        manualDuration: recordsDuration(
          activityType: MANUAL
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        productiveDuration: recordsDuration(
          productivity: PRODUCTIVE
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        unproductiveDuration: recordsDuration(
          productivity: UNPRODUCTIVE
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        neutralDuration: recordsDuration(
          productivity: NEUTRAL
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        activityRecords(
          activityType: SCREENCAST
          orderBy: { column: ENDING_TIME, order: DESC }
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
          page: $page
        ) {
          total
          currentPage
          hasMorePages
          data {
            duration
            mouseMoves
            memo
            keyClicks
            startedAt
            endedAt
            record {
              ... on Screencast {
                uuid
                title
              }
            }
          }
        }
      }
    }
  `,
  GET_DURATION: gql`
    query getDurations(
      $startTime: DateTime!
      $endTime: DateTime!
      $keyword: [String!]
      $uuid: String
      $timezone: String
    ) {
      me(uuid: $uuid) {
        id
        recordsDuration: activityDuration(
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        manualDuration: recordsDuration(
          activityType: MANUAL
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        productiveDuration: recordsDuration(
          productivity: PRODUCTIVE
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        unproductiveDuration: recordsDuration(
          productivity: UNPRODUCTIVE
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
      }
    }
  `,

  GET_ACTIVITY_BY_TYPE: gql`
    query userActivityByType(
      $keyword: [String!]
      $page: Int
      $first: Int
      $productivity: Productivity
      $uuid: String
      $startTime: DateTime!
      $endTime: DateTime!
      $timezone: String
    ) {
      me(uuid: $uuid) {
        name
        email
        id
        topUses(
          activityType: [WEBSITE, APPLICATION]
          productivity: $productivity
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
          page: $page
          first: $first
        ) {
          total
          count
          data {
            duration
            activityType
            name
            productivity
          }
        }
      }
    }
  `,
  GET_DAILY_ACTIVITIES: gql`
    query dailyActivities(
      $startTime: DateTime!
      $endTime: DateTime!
      $userId: String!
      $projectId: [String!]
      $timezone: String
    ) {
      user(uuid: $userId) {
        id
        dailyActivities(
          project: { keyword: $projectId, searchKey: UUID }
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          first: -1
        ) {
          data {
            date
            duration
          }
        }
      }
    }
  `,
  GET_ALL_DAILY_ACTIVITIES: gql`
    query allDailyActivities(
      $startTime: DateTime!
      $endTime: DateTime!
      $userId: [String!]
      $projectId: [String!]
      $timezone: String
      $first: Int
      $page: Int
      $sortBy: UserSortType!
      $sortDirection: SortDirection!
      $tags: [String!]
      $onlineStatus: Boolean
      $activities: [String!]
    ) {
      users(
        user: { searchKey: UUID, type: EXACT, keyword: $userId }
        project: { keyword: $projectId, searchKey: UUID }
        first: $first
        page: $page
        sortBy: {
          type: $sortBy
          project: { searchKey: UUID, keyword: $projectId }
          direction: $sortDirection
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
        }
        filter: {
          projectUid: $projectId
          tag: $tags
          isOnline: $onlineStatus
          activity: $activities
        }
      ) {
        total
        data {
          id
          uuid
          name
          avatar
          tags(project: { keyword: $projectId, searchKey: UUID }) {
            id
            name
            color
            description
          }
          isOnline(project: { keyword: $projectId, searchKey: UUID })
          dailyActivities(
            project: { keyword: $projectId, searchKey: UUID }
            between: {
              startTime: $startTime
              endTime: $endTime
              timezone: $timezone
            }
            first: -1
          ) {
            data {
              date
              duration
              idlePercent
            }
          }
        }
      }
    }
  `,
  GET_IDLE_TIME: gql`
    query idleTime(
      $uuid: String
      $keyword: [String!]
      $startTime: DateTime!
      $endTime: DateTime!
      $timezone: String
    ) {
      user(uuid: $uuid) {
        uuid
        # idleDuration(
        #   between: { startTime: $startTime, endTime: $endTime, timezone: $timezone }
        #   project: { searchKey: UUID, keyword: $keyword }
        # )
        idlePercent(
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { searchKey: UUID, keyword: $keyword }
        )
        unproductiveDuration: recordsDuration(
          project: { searchKey: UUID, keyword: $keyword }
          productivity: UNPRODUCTIVE
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
        )
        recordsDuration: activityDuration(
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        recordedDuration: recordsDuration(
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        manualDuration: recordsDuration(
          activityType: MANUAL
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $keyword, searchKey: UUID }
        )
        topUses(
          activityType: [WEBSITE, APPLICATION]
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { searchKey: UUID, keyword: $keyword }
        ) {
          data {
            activityType
            name
            duration
            idlePercent
            productivity
          }
        }
      }
    }
  `,
  GET_WEEKLY_TIMELINE: gql`
    query getWeeklyTime(
      $keyword: [String!]
      $page: Int
      $first: Int
      $startTime: DateTime!
      $endTime: DateTime!
      $timezone: String
      $projectId: [String!]
      $sortBy: UserSortType!
      $sortDirection: SortDirection!
      $tags: [String!]
      $isOnline: Boolean
      $startOfMonth: DateTime!
      $endOfMonth: DateTime!
    ) {
      users(
        user: { searchKey: UUID, keyword: $keyword, type: EXACT }
        project: { keyword: $projectId, searchKey: UUID }
        page: $page
        first: $first
        sortBy: {
          type: $sortBy
          project: { searchKey: UUID, keyword: $projectId }
          direction: $sortDirection
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
        },
        filter: {
          projectUid: $projectId
          tag: $tags
          isOnline: $isOnline
        }
      ) {
        total
        data {
          name
          uuid
          avatar
          isOnline(project: { keyword: $projectId, searchKey: UUID })
          monthlyDuration:activityDuration(
            project: { keyword: $projectId, searchKey: UUID }
            between: {
              startTime: $startOfMonth
              endTime: $endOfMonth
              timezone: $timezone
            }
          )
          
          dailyActivities(
            between: {
              startTime: $startTime
              endTime: $endTime
              timezone: $timezone
            }
            project: { keyword: $projectId, searchKey: UUID }
            first: -1
          ) {
            data {
              date
              duration
              # recordsDuration
              idlePercent
            }
          }
          projectSettings(
            project: { keyword: $projectId, searchKey: UUID }
            type: PROJECTTIMELIMIT
            first: 1
          ) {
            data {
              information {
                ...on ProjectTimeLimit {
                  type
                  hours
                }
              }
            }
          }
        }
      }
    }
  `,
  GET_WEEKLY_SPENDING: gql`
    query getWeeklySpend(
      $keyword: [String!]
      $page: Int
      $first: Int
      $startTime: DateTime!
      $endTime: DateTime!
      $timezone: String
      $projectId: [String!]
      $sortBy: UserSortType!
      $sortDirection: SortDirection!
      $tags: [String!]
      $isOnline: Boolean
      $startOfMonth: DateTime!
      $endOfMonth: DateTime!
    ) {
      project(project: { searchKey: UUID, keyword: $projectId }) {
        name
        activityAmount(between: { startTime: $startTime, endTime: $endTime, timezone: $timezone })
        dailySpendings(between: { startTime: $startTime, endTime: $endTime, timezone: $timezone }, first: -1) {
          data {
            date
            amount
          }
        }
      }
      users(
        user: { searchKey: UUID, keyword: $keyword, type: EXACT }
        project: { keyword: $projectId, searchKey: UUID }
        page: $page
        first: $first
        sortBy: {
          type: $sortBy
          project: { searchKey: UUID, keyword: $projectId }
          direction: $sortDirection
          between: { startTime: $startTime, endTime: $endTime, timezone: $timezone }
        }
        filter: { projectUid: $projectId, tag: $tags, isOnline: $isOnline }
      ) {
        total
        data {
          name
          uuid
          avatar
          isOnline(project: { keyword: $projectId, searchKey: UUID })
          monthlyDuration: activityDuration(
            project: { keyword: $projectId, searchKey: UUID }
            between: { startTime: $startOfMonth, endTime: $endOfMonth, timezone: $timezone }
          )
          activityAmount(
            between: { startTime: $startTime, endTime: $endTime, timezone: $timezone }
            project: { keyword: $projectId, searchKey: UUID }
          )
          dailySpendings(
            between: { startTime: $startTime, endTime: $endTime, timezone: $timezone }
            project: { keyword: $projectId, searchKey: UUID }
            first: -1
          ) {
            data {
              date
              amount
            }
          }
          dailyActivities(
            between: { startTime: $startTime, endTime: $endTime, timezone: $timezone }
            project: { keyword: $projectId, searchKey: UUID }
            first: -1
          ) {
            data {
              date
              duration
              idlePercent
              __typename
            }
            __typename
          }
          projectSettings(
            project: { keyword: $projectId, searchKey: UUID }
            type: PROJECTTIMELIMIT
            first: 1
          ) {
            data {
              information {
                ... on ProjectTimeLimit {
                  type
                  hours
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
    }
  `,
  GET_WORK_PATTERN: gql`
    query getWorkPattern(
      $startTime: DateTime!
      $endTime: DateTime!
      $projectId: [String!]
      $userId: String!
      $timezone: String
    ) {
      me(uuid: $userId) {
        activities(
          orderBy: { column: ENDING_TIME, order: DESC }
          between: {
            startTime: $startTime
            endTime: $endTime
            timezone: $timezone
          }
          project: { keyword: $projectId, searchKey: UUID }
          first: -1
        ) {
          data {
            uuid
            startedAt
            manualDuration: recordsDuration(activityType: MANUAL)
            endedAt
            deletedTimings {
              data {
                startedAt
                endedAt
              }
            }
          }
        }
      }
    }
  `,

  GET_PENDING_MANUAL_TIME: gql`
    query pendingManualTime($projectId: String!, $userId: String!) {
      project(uuid: $projectId) {
        pendingManualTimes(user: { keyword: [$userId], searchKey: UUID }) {
          total
          data {
            id
            # uuid
            startedAt
            endedAt
            remarks
            user {
              uuid
            }
          }
        }
      }
    }
  `,

  GET_ALL_MANUAL_TIME: gql`
    query getAllManualTime($projectId: String!, $first: Int, $page: Int, $startTime: DateTime!, $endTime: DateTime!, $timezone: String) {
      project(uuid: $projectId) {
        pendingManualTimes(
          first: $first
          page: $page
          between:{startTime:$startTime, endTime:$endTime, timezone:$timezone}
        ) {
          total
          data {
            id
            startedAt
            endedAt
            remarks
            user {
              uuid
              name
              avatar
            }
          }
        }
      }
    }
  `,
  MY_PENDING_MANUAL_TIME: gql`
    query getMyPendingManualTime($projectId: [String!]) {
      me {
        pendingManualTimes(
          project:{keyword:$projectId, searchKey:UUID}
        ){
          total
          data {
            id
            startedAt
            endedAt
            remarks
          }
        }
      }
    }
  `,
  ALL_SCREENCASTS: gql`
    query getAllScreencasts($projectUid: String!, $startTime: DateTime!, $endTime: DateTime!, $timezone: String, $first: Int, $page: Int) {
      project(uuid: $projectUid) {
        activityRecords(
          activityType: SCREENCAST
          orderBy: { column: ENDING_TIME, order: DESC }
          between: { startTime: $startTime, endTime: $endTime, timezone: $timezone }
          first: $first
          page: $page
        ) {
          total
          hasMorePages
          currentPage
          data {
            duration
            keyClicks
            mouseMoves
            record {
              ... on Screencast {
                uuid
                title
              }
            }
            startedAt
            endedAt
            startingTime
            endingTime
            activity {
              user {
                uuid
                name
                avatar
              }
            }
          }
        }
      }
    }
  `,
}
